import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import FooterSticky from 'components/Footer/FooterSticky';

const PromotionPageLayout = ({ children, className }) => {
  return (
    <div className={cn('promotions-page', className)}>
      {children}
      <FooterSticky className="footer_mt" />
    </div>
  );
};

PromotionPageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PromotionPageLayout;
